'use strict';

var DelayActionMixin = {
  componentWillUnmount: function () {
    this.cancelScheduledAction();
  },

  scheduleAction: function (action, delay) {
    this.cancelScheduledAction();
    this._delayedActionTimeout = window.setTimeout(action, delay);
  },

  cancelScheduledAction: function () {
    if (this._delayedActionTimeout) {
      window.clearTimeout(this._delayedActionTimeout);
      this._delayedActionTimeout = null;
    }
  }
};

module.exports = DelayActionMixin;


/** WEBPACK FOOTER **
 ** ./mixins/DelayActionMixin.js
 **/